import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { ocrPan } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data6 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const OcrPan = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [panData, setPanData] = useState([]);
    const [showPanData, setShowPanData] = useState(false)
    const [errors, setErrors] = useState({});
    const [profileData, setProfileData] = useState({});
    const [pan, setPan] = useState("");
    const { serviceName } = useService();
    const [ocrPanFile, setOcrPanFile] = useState(null);


    // Fetch profile data on mount
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const validateForm = (ocrPanFile) => {
        const errors = {};

        if (!ocrPanFile) {
            errors.ocrPanFile = "PAN file is required.";
        } else {
            const allowedTypes = [
                "application/pdf",
                "image/jpeg",
                "image/jpg",
                "image/png"
            ];

            if (!allowedTypes.includes(ocrPanFile.type)) {
                errors.ocrPanFile = "Only PDF, JPG, or PNG files are allowed.";
            }
        }

        return errors;
    };





    const handleSubmit = async () => {

        const validationErrors = validateForm(ocrPanFile);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) return;

        try {
            setIsLoading(true);

            const formData = new FormData();
            formData.append("api_id", profileData?.user_id);
            formData.append("api_key", profileData?.api_key);
            formData.append("token_id", profileData?.token_id);
            formData.append("pdf", ocrPanFile);

            const response = await ocrPan(formData);

            const statusCode = response?.status?.code || response?.status;

            if (statusCode === 200) {

                const rcData = response?.data;  // <-- this is an ARRAY, perfect

                if (rcData) {
                    setPanData(rcData); // <-- directly store the array
                    setShowPanData(true);
                    showSuccessToast(response.message, "Pan Details fetched successfully.");
                    setPan("");
                    setErrors({});
                } else {
                    showErrorToast("Unexpected API format.");
                }
                console.log("respoan", panData);
            }


            else if (statusCode === 422) {
                showErrorToast(response.data.message || "Invalid format");
            }

            else if (statusCode === 500) {
                showErrorToast(response.data.message || "Server error");
            }

            else {
                showErrorToast(response.status?.message || "Something went wrong");
            }

        } catch (error) {
            console.error("Pan Error:", error);
            showErrorToast("Failed to verify Pan Father Details.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading={serviceName} />

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>
                <InputWithLabel
                    type="file"
                    label="OCR PAN"
                    placeholder="Upload PAN PDF"
                    className="p-1 rounded shadow-lg cursor-pointer shadow-blue-500/50 border border-blue-600"
                    name="ocr_pan"
                    id="ocr_pan"
                    required={true}
                    accept="application/pdf" 
                    onChange={(e) => setOcrPanFile(e.target.files[0])}
                    error={errors.ocrPanFile}
                />


                <div>
                    <Button
                        type="button"
                        className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
                        id="verifyMob"
                        name="verifyMob"
                        text="Verify"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
            {Array.isArray(panData) && panData.length > 0 && (

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4 ">

                    <div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-110">
                        <h2 className="text-lg font-semibold text-yellow-800 mb-3">Raw Response (JSON)</h2>
                        <pre className="text-sm bg-gray-100 p-2 rounded-md">{JSON.stringify(panData, null, 2)}</pre>
                    </div>
                    <div className="bg-white border border-green-300 rounded-md shadow-lg p-4">
                        <h3 className="font-semibold mb-2">PAN Details</h3>

                        {panData.map((item, index) => (
                            <div key={index} className="space-y-1">
                                <p>
                                    <strong>Name:</strong> {item?.details?.name?.value}
                                </p>
                                <p>
                                    <strong>Father Name:</strong> {item?.details?.father?.value}
                                </p>
                                <p>
                                    <strong>PAN No:</strong> {item?.details?.pan_no?.value}
                                </p>
                                <p>
                                    <strong>DOB:</strong> {item?.details?.date?.value}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            )}


        </>
    );
};

export default OcrPan;
